module.exports = __webpack_public_path__ + "img/2-7-luxor.3060dd6e.jpg";